import React, { FC, useState } from 'react';
import { useGetProgramMasterData } from 'src/api/mutations/useGetProgramMasterData';
import './IncreaseStrengthSteps.scss'; // Reusing the same SCSS for consistency
import { ReactComponent as Technique_focused_trainingIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/technique_focused_training.svg';
import { ReactComponent as Stability_trainingIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/stability_training.svg';
import { ReactComponent as Mobility_controlIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/mobility_control.svg';
import { ReactComponent as PrehabIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/prehab.svg';

interface InjuryPreventionStep3Props {
  value?: string;
  onNext?: (value: string) => void;
}

const iconMap: Record<string, React.ReactNode> = {
  stability_training: <Stability_trainingIcon />,
  mobility_control: <Mobility_controlIcon />,
  prehab: <PrehabIcon />,
  technique_focused_training: <Technique_focused_trainingIcon />,
};

// How should this goal be approached?
// Choose the training type that best suits your client
export const InjuryPreventionStep3: FC<InjuryPreventionStep3Props> = ({ value, onNext }) => {
  const [selectedApproach, setSelectedApproach] = useState<string>(value || '');
  const { data: programMasterData, isLoading, isError } = useGetProgramMasterData();

  const groupData = programMasterData?.trainingGoalApproaches?.groups?.find(
    (g: any) => g.goalId === 'injury_prevention',
  );

  const approaches = groupData?.options
    ? [...groupData.options].sort((a: any, b: any) => a.order - b.order)
    : [];

  if (isLoading) {
    return <div className="increase-strength-step">{'Loading options...'}</div>;
  }

  if (isError || !groupData) {
    return <div className="increase-strength-step">{'Error loading options.'}</div>;
  }

  return (
    <div className="increase-strength-step">
      <h2 className="step-title">{groupData?.title}</h2>
      <p className="step-subtitle">{groupData?.subtitle}</p>

      <div className="goal-buttons">
        {approaches.map((approach: any) => (
          <button
            key={approach.id}
            className={`goal-btn ${selectedApproach === approach.slug ? 'selected' : ''}`}
            onClick={() => {
              setSelectedApproach(approach.slug);
              if (onNext) onNext(approach.slug);
            }}
          >
            <div className="goal-icon">{iconMap[approach.id]}</div>
            <span className="goal-label">{approach.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
